import React from 'react'

import { Link } from 'react-router-dom';

const IndustrialTraining = () => {

    

    return (
        <>
            <marquee behavior="scroll" scrollamount="14" bgcolor="#fdc800" height="40pxl">
                <h3> Industrial Training Institute Registration Apply Easy 3 Step
                </h3>
            </marquee>



            <div className="slider1-area overlay-default">
                <div className="bend niceties preview-1">
                    <div id="ensign-nivoslider-3" className="slides">
                        <img src="/images/it-img.jpg" alt="slider" title="#slider-direction-1" />
                        <img src="/images/it-img2.jpg" alt="slider" title="#slider-direction-2" />

                    </div>
                    <div id="slider-direction-1" className="t-cn slider-direction">
                        <div className="slider-content s-tb slide-1">
                            <div className="title-container s-tb-c">
                                <div className="slider-btn-area">
                                    <Link to='/contact' target='_blank' className="join-now-btn">Admission Enquiry</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="slider-direction-2" className="t-cn slider-direction">
                        <div className="slider-content s-tb slide-2">
                            <div className="title-container s-tb-c">
                                <div className="slider-btn-area">
                                    <Link to='/contact' target='_blank' className="join-now-btn">Admission Enquiry</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="lecturers-page-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <div className="lecturers-contact-info">
                                <img src="/images/industrial.jpg" className="img-responsive" alt="team" />
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                            <h3 className="title-default-left title-bar-big-left-close">About Industrial Training Program</h3>
                            <p>Candidates seeking short-term job-oriented courses after passing class 10 board exams can apply for Industrial Training courses after 10th.Industrial Training courses after 10th are available in different fields and candidates can pick courses on the basis of their interest with (Information Technology and Technical Education Council) ITT Council. </p>
                            <p>Once the Class 10th results are announced by CBSE, ICSE and most of the state education boards, it will be time for students to decide what to do next. If you think that industrial work and small-scale businesses are your things then Industrial Training courses after 10th can help you in getting good jobs after completing the course. Industrial Training courses after 10th are for students who want to pursue short-term courses in order to pursue jobs.</p>
                            <p>ITIs or Industrial Training Institutes are usually organisations or training centres that provide courses to students seeking easy employment just after completing school. Our Vocational centres train students in performing certain tasks to enable them to get a job by the end of the course duration. These courses can be technical as well as non-technical and students can pick one according to their preferences.
                            </p>
                            <h3 className="title-default-left title-bar-big-left-close">Industrial Training Course Benefits</h3>
                            <p>Not everyone has to be a doctor or engineer in the world to survive. If you plan to be a mechanic or a technician, there is no need to pursue a diploma or a complete degree. Industrial Training courses are specially designed for these purposes, have a look at the benefits of Industrial Training Courses:</p>
                            <ul className="course-feature2">
                                <li>Easy Employment</li>
                                <li>Early Job settlement</li>
                                <li>No Need to Study a Regular Degree of 3 Years</li>
                                <li>Industrial Training Courses can be Studied after 8th, 10th and 12th Standard.</li>
                            </ul>
                        </div>
                    </div>


                    <div className="row p-3">
                        <h2 className="title-center pt-3">Industrial and Vocational Training Program </h2>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-graduation-cap" aria-hidden="true" />
                                <h3><a href="#">Tool &amp; Die Maker</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-user" aria-hidden="true" />
                                <h3><a href="#">Diesel Mechanic</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-bed" aria-hidden="true" />
                                <h3><a href="#">Pump Operator</a></h3>
                            </div>
                        </div>
                    </div>


                    <div className="row p-3">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-graduation-cap" aria-hidden="true" />
                                <h3><a href="#">Fitter</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-user" aria-hidden="true" />
                                <h3><a href="#">Turner</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-bed" aria-hidden="true" />
                                <h3><a href="#">Dress Making</a></h3>
                            </div>
                        </div>
                    </div>


                    <div className="row p-3">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-graduation-cap" aria-hidden="true" />
                                <h3><a href="#">Manufacture Foot Wear</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-user" aria-hidden="true" />
                                <h3><a href="#">Secretarial Practice</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-bed" aria-hidden="true" />
                                <h3><a href="#">Refrigeration Repairing</a></h3>
                            </div>
                        </div>
                    </div>



                    <div className="row p-3">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-graduation-cap" aria-hidden="true" />
                                <h3><a href="#">Bleaching &amp; Dyeing Calico Print</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-user" aria-hidden="true" />
                                <h3><a href="#">Electrician</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-bed" aria-hidden="true" />
                                <h3><a href="#">Automobile Training</a></h3>
                            </div>
                        </div>
                    </div>

                    <div className="row p-3">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-graduation-cap" aria-hidden="true" />
                                <h3><a href="#">Wireman</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-user" aria-hidden="true" />
                                <h3><a href="#">Plumber</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-bed" aria-hidden="true" />
                                <h3><a href="#">Welder</a></h3>
                            </div></div> </div>


                    <div className="row p-3">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-bed" aria-hidden="true" />
                                <h3><a href="#">Mobile Repairing</a></h3>
                            </div>
                        </div>
                    </div>





                </div>
            </div>



        </>
    )
}

export default IndustrialTraining